import { APP_PERMISSIONS } from '@user-management/permissions';

import { type AppMenuConfig } from '../../types';

export function useGetSidebarItem(): AppMenuConfig[] {
  return [
    {
      section: '',
      items: [
        {
          label: 'Users',
          url: '/user-management',
          iconName: 'USERS',
          permission: {
            requiredPermission: [APP_PERMISSIONS.SETTING.USER.VIEW],
          },
        },
        {
          label: 'Roles & Permissions',
          url: '/roles-and-permissions',
          iconName: 'ROLES',
          permission: {
            requiredPermission: [APP_PERMISSIONS.SETTING.ROLE.VIEW],
          },
        },
      ],
    },
  ];
}
